import { render, staticRenderFns } from "./GuideCard.vue?vue&type=template&id=e0bc0bda&scoped=true"
import script from "./GuideCard.vue?vue&type=script&lang=js"
export * from "./GuideCard.vue?vue&type=script&lang=js"
import style0 from "./GuideCard.vue?vue&type=style&index=0&id=e0bc0bda&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0bc0bda",
  null
  
)

export default component.exports